import { Controller } from "@hotwired/stimulus"

// Fetches `url` after `every` ms and puts what comes back in this element's
// place: the admin page's Rails row watching a re-run (VenueRefresh) — the server
// writes a line per rail, the row shows the next one on each turn, and the
// form below keeps whatever a hand is typing. The server's row carries this
// controller again while the run is live, so the loop ends with the run.
export default class extends Controller {
  static values = { url: String, every: { type: Number, default: 8000 } }

  connect() {
    this.timer = setTimeout(() => this.poll(), this.everyValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  async poll() {
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: "text/html" } })
      if (!response.ok) throw new Error(response.status)
      this.element.outerHTML = await response.text()
    } catch {
      this.timer = setTimeout(() => this.poll(), this.everyValue)
    }
  }
}
